import { PALTA_PAYMENTS_V2_API_KEY } from "@/constants/prices";
import { PaymentClientSettings } from "@palta-brain/payments/dist/cjs";

export const PALTA_PAYMENTS_API = "https://api.payments.zing.coach";

export enum PAYMENT_METHODS {
    CARD = "card",
    PAYPAL = "paypal",
    APPLE = "apple",
}

export const enum CheckoutContainersIds {
    PayPal = "#checkout-container-paypal",
    Card = "#checkout-container-card",
    Apple = "#checkout-container-apple",
}

export const enum PaymentProviders {
    Primer = "primer",
    BrainTree = "braintree",
}

export const preparePaymentContainers = (isApplePayAvailable: boolean | null) => {
    const pricesContainer = document.querySelector("#checkout-container-paypal");
    const cardPricesContainer = document.querySelector("#checkout-container-card");
    const paymentSystemPricesContainer =
        isApplePayAvailable && document.querySelector(`#checkout-container-apple`);
    if (pricesContainer) {
        pricesContainer.innerHTML = "";
    }
    if (cardPricesContainer) {
        cardPricesContainer.innerHTML = "";
    }
    if (paymentSystemPricesContainer) {
        paymentSystemPricesContainer.innerHTML = "";
    }
};

const getMetadata = (isApplePayAvailable: boolean | null) => {
    let metadata: Record<string, number> = {
        paypal: 1,
        card: 1,
    };

    if (isApplePayAvailable) {
        metadata = {
            ...metadata,
            [PAYMENT_METHODS.APPLE]: 1,
        };
    }

    return metadata;
};

export const getPaymentSettings = ({
    isApplePayAvailable,
    onError,
    onPaymentStatusChange,
}: {
    isApplePayAvailable: boolean | null;
    onError: PaymentClientSettings["onError"];
    onPaymentStatusChange: PaymentClientSettings["onPaymentStatusChange"];
}): PaymentClientSettings => {
    return {
        apiEndpoint: PALTA_PAYMENTS_API,
        apiKey: PALTA_PAYMENTS_V2_API_KEY,
        metadata: getMetadata(isApplePayAvailable),
        reCaptchaEnabled: null,
        reCaptchaSiteKey: null,
        onError,
        onPaymentStatusChange,
    };
};
